<header class="revenue-scheme-header">
  <div class="header-main">
    <div class="header-left">
      <div class="header-icon">
        <i class="pi pi-chart-line"></i>
      </div>
      <div class="header-text">
        <h1>Revenue Scheme Dashboard</h1>
        <p>Analytical view of proposals, stages, and execution progress</p>
      </div>
    </div>
    <div class="header-right">
      <button class="clean-primary-btn" (click)="navigateto()">
        <i class="pi pi-plus-circle"></i>
        Initiate New Proposal
      </button>
    </div>
  </div>
</header>

<!-- ===== TOP KPI CARDS (OTE / LTE / STE) ===== -->
<section class="revenue-kpi-section" aria-label="Summary metrics">
  <app-summary-metrics
    labelSet="revenue"
    [totalProposals]="totalProposals"
    [totalContracts]="totalContracts"
    [totalPreLaunch]="totalPreLaunch"
    [totalForLaunch]="totalForLaunch"
    [totalShortClosed]="totalShortClosed"
    [completedProposals]="completedProposals"
    [loading]="dashboardLoading"
    [schemeWiseGrant]="schemeWiseGrant"
    [schemeWiseProposal]="schemeWiseProposal"
    [schemeWisePrelaunch]="schemeWisePrelaunch"
    [schemeWiseForlaunch]="schemeWiseForlaunch"
    [schemeWiseShortClosed]="schemeWiseShortClosed"
    [schemeWiseCompleted]="schemeWiseCompleted"
    [contractSchemesOrder]="['OTE', 'LTE', 'STE']"
    [proposalSchemesOrder]="['OTE', 'LTE', 'STE']"
    [preLaunchSchemesOrder]="['OTE', 'LTE', 'STE']"
    [forLaunchSchemesOrder]="['OTE', 'LTE', 'STE']"
    [shortClosedSchemesOrder]="['OTE', 'LTE', 'STE']"
    [completedSchemesOrder]="['OTE', 'LTE', 'STE']">
  </app-summary-metrics>
</section>

<div class="revenue-dashboard-wrapper">
  <!-- 1. Full-width: Stage-wise Proposal Progress -->
  <section class="revenue-chart-section revenue-chart-full">
    <p-card styleClass="revenue-chart-card">
      <ng-template pTemplate="header">
        <div class="revenue-chart-header">
          <i class="pi pi-sitemap revenue-chart-icon"></i>
          <div>
            <h4 class="revenue-chart-title">Stage-wise Proposal Progress</h4>
            <p class="revenue-chart-subtitle">Pending / In Progress / Completed by stage</p>
          </div>
          <button type="button" class="p-button p-button-text p-button-rounded" (click)="openFullscreen('stageProgress')" icon="pi pi-window-maximize" pTooltip="Expand"></button>
        </div>
      </ng-template>
      <ng-template pTemplate="content">
        <div class="revenue-chart-wrap revenue-chart-bar">
          <p-chart type="bar" [data]="stageProgressChart" [options]="stageProgressChartOptions"></p-chart>
        </div>
      </ng-template>
    </p-card>
  </section>

  <!-- 2. Full-width: Execution & Closure Progress -->
  <section class="revenue-chart-section revenue-chart-full">
    <p-card styleClass="revenue-chart-card">
      <ng-template pTemplate="header">
        <div class="revenue-chart-header">
          <i class="pi pi-list revenue-chart-icon"></i>
          <div>
            <h4 class="revenue-chart-title">Execution &amp; Closure Progress</h4>
            <p class="revenue-chart-subtitle">Kick Off through Project Closure</p>
          </div>
          <button type="button" class="p-button p-button-text p-button-rounded" (click)="openFullscreen('executionProgress')" icon="pi pi-window-maximize" pTooltip="Expand"></button>
        </div>
      </ng-template>
      <ng-template pTemplate="content">
        <div class="revenue-chart-wrap revenue-chart-bar">
          <p-chart type="bar" [data]="executionProgressChart" [options]="executionProgressChartOptions"></p-chart>
        </div>
      </ng-template>
    </p-card>
  </section>

  <!-- 5. Proposal-wise Stage Tracking Table (same design as Make) -->
  <section class="stage-tracking-section">
    <div class="card stage-tracking-card">
      <div class="card-header section-header-unified d-flex justify-content-between align-items-center flex-wrap gap-2">
        <div>
          <h5 class="mb-0 section-title">Proposal-wise Stage Tracking</h5>
          <small class="text-muted section-subtitle">Status across Revenue Scheme stages</small>
        </div>
        <div class="stage-tracking-legend d-flex align-items-center gap-3 flex-wrap">
          <span class="stage-legend-item"><span class="stage-dot stage-dot-completed"></span> Completed</span>
          <span class="stage-legend-item"><span class="stage-dot stage-dot-progress"></span> In Progress</span>
          <span class="stage-legend-item"><span class="stage-dot stage-dot-pending"></span> Pending</span>
        </div>
      </div>
      <div class="card-body p-0">
        <div class="stage-tracking-toolbar d-flex align-items-center justify-content-between flex-wrap gap-2 px-3 py-2 border-bottom">
          <span class="p-input-icon-left stage-tracking-search-wrap">
            <i class="pi pi-search"></i>
            <input type="text" pInputText class="stage-tracking-search"
              [(ngModel)]="revenueStageFilters.proposal_title"
              (input)="applyRevenueStageFilter()"
              placeholder="Search by proposal ID or title..." />
          </span>
          <button *ngIf="revenueStageFilters.proposal_title" type="button" class="p-button p-button-text p-button-sm" (click)="revenueStageFilters.proposal_title=''; applyRevenueStageFilter()" title="Clear search">
            <i class="pi pi-times"></i> Clear
          </button>
        </div>
        <div class="overflow-x-auto overflow-y-auto max-h-[320px]">
          <table class="w-full text-sm stage-tracking-table">
            <thead class="bg-blue-950 sticky top-0 z-10">
              <tr>
                <th class="px-2 py-2 text-white text-left sortable" (click)="sortRevenueStage('proposal_title')">
                  Proposal Title <i class="pi sort-icon" [ngClass]="revenueStageSortField === 'proposal_title' ? (revenueStageSortOrder === 1 ? 'pi-sort-up' : 'pi-sort-down') : 'pi-sort-alt'"></i>
                </th>
                <th class="px-2 py-2 text-white text-left sortable" (click)="sortRevenueStage('category')">
                  Category <i class="pi sort-icon" [ngClass]="revenueStageSortField === 'category' ? (revenueStageSortOrder === 1 ? 'pi-sort-up' : 'pi-sort-down') : 'pi-sort-alt'"></i>
                </th>
                <th class="px-2 py-2 text-white text-left sortable" (click)="sortRevenueStage('current_stage')">
                  Current Stage <i class="pi sort-icon" [ngClass]="revenueStageSortField === 'current_stage' ? (revenueStageSortOrder === 1 ? 'pi-sort-up' : 'pi-sort-down') : 'pi-sort-alt'"></i>
                </th>
                <th class="px-2 py-2 text-white text-left sortable" (click)="sortRevenueStage('overall_status')">
                  Overall Status <i class="pi sort-icon" [ngClass]="revenueStageSortField === 'overall_status' ? (revenueStageSortOrder === 1 ? 'pi-sort-up' : 'pi-sort-down') : 'pi-sort-alt'"></i>
                </th>
                <th *ngFor="let stage of revenueStageLabels" class="px-2 py-2 text-white text-center">{{ stage }}</th>
                <th class="px-2 py-2 text-white text-left sortable" (click)="sortRevenueStage('last_updated')">
                  Last Updated On <i class="pi sort-icon" [ngClass]="revenueStageSortField === 'last_updated' ? (revenueStageSortOrder === 1 ? 'pi-sort-up' : 'pi-sort-down') : 'pi-sort-alt'"></i>
                </th>
                <th class="px-2 py-2 text-white text-center sortable" (click)="sortRevenueStage('delay_days')">
                  Delay Days <i class="pi sort-icon" [ngClass]="revenueStageSortField === 'delay_days' ? (revenueStageSortOrder === 1 ? 'pi-sort-up' : 'pi-sort-down') : 'pi-sort-alt'"></i>
                </th>
              </tr>
              <tr class="bg-gray-100">
                <th class="p-1"><span class="filter-input-with-icon"><i class="pi pi-search filter-search-icon"></i><input [(ngModel)]="revenueStageFilters.proposal_title" (input)="applyRevenueStageFilter()" class="w-full border rounded px-1 text-xs" placeholder="" /></span></th>
                <th class="p-1"><span class="filter-input-with-icon"><i class="pi pi-search filter-search-icon"></i><input [(ngModel)]="revenueStageFilters.category" (input)="applyRevenueStageFilter()" class="w-full border rounded px-1 text-xs" placeholder="" /></span></th>
                <th class="p-1"><span class="filter-input-with-icon"><i class="pi pi-search filter-search-icon"></i><input [(ngModel)]="revenueStageFilters.current_stage" (input)="applyRevenueStageFilter()" class="w-full border rounded px-1 text-xs" placeholder="" /></span></th>
                <th class="p-1"><span class="filter-input-with-icon"><i class="pi pi-search filter-search-icon"></i><input [(ngModel)]="revenueStageFilters.overall_status" (input)="applyRevenueStageFilter()" class="w-full border rounded px-1 text-xs" placeholder="" /></span></th>
                <th *ngFor="let _ of revenueStageLabels" class="p-1"><input class="w-full border rounded px-1 text-xs" placeholder="" readonly /></th>
                <th class="p-1"><span class="filter-input-with-icon"><i class="pi pi-search filter-search-icon"></i><input [(ngModel)]="revenueStageFilters.last_updated" (input)="applyRevenueStageFilter()" class="w-full border rounded px-1 text-xs" placeholder="" /></span></th>
                <th class="p-1"><span class="filter-input-with-icon"><i class="pi pi-search filter-search-icon"></i><input [(ngModel)]="revenueStageFilters.delay_days" (input)="applyRevenueStageFilter()" class="w-full border rounded px-1 text-xs" placeholder="" /></span></th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200">
              <tr *ngFor="let proposal of revenueStageTablePaginatedData; let i = index" [ngClass]="{ 'bg-white': i % 2 === 0, 'bg-slate-200': i % 2 !== 0 }">
                <td class="px-2 py-1"><span class="fw-semibold text-primary" [pTooltip]="proposal.proposal_title">{{ proposal.proposal_title }}</span></td>
                <td class="px-2 py-1">{{ proposal.category }}</td>
                <td class="px-2 py-1"><p-tag [value]="getCurrentStage(proposal)" severity="info" class="p-tag-rounded"></p-tag></td>
                <td class="px-2 py-1">{{ getOverallStatus(proposal) }}</td>
                <td *ngFor="let stageKey of revenueStageKeys" class="px-2 py-1 text-center">
                  <span class="stage-status-dot" [ngClass]="getStageDotClass(getStageStatus(proposal, stageKey))" [pTooltip]="getStageStatus(proposal, stageKey)" tooltipPosition="top"></span>
                </td>
                <td class="px-2 py-1">{{ proposal.last_updated | date:'dd/MM/yyyy' }}</td>
                <td class="px-2 py-1">{{ getDaysInCurrentStage(proposal) }}</td>
              </tr>
              <tr *ngIf="revenueStageTablePaginatedData.length === 0">
                <td colspan="14" class="text-center text-muted py-4"><i class="pi pi-info-circle me-2"></i> No proposal stage data available.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-between align-items-center p-3 bg-gray-100 border-top text-sm flex-wrap gap-2">
          <div>Showing {{ revenueStageTableStartEntry }} to {{ revenueStageTableEndEntry }} of {{ filteredRevenueStageData.length }} entries</div>
          <div class="d-flex align-items-center gap-2 flex-wrap">
            <button type="button" class="px-2 py-1 border rounded" (click)="changeRevenueStagePage(1)">«</button>
            <button type="button" class="px-2 py-1 border rounded" (click)="changeRevenueStagePage(revenueStageTableCurrentPage - 1)">‹</button>
            <button *ngFor="let page of revenueStageTablePages" type="button" class="px-3 py-1 rounded" [class.bg-primary]="page === revenueStageTableCurrentPage" [class.text-white]="page === revenueStageTableCurrentPage" [class.border]="page !== revenueStageTableCurrentPage" (click)="changeRevenueStagePage(page)">{{ page }}</button>
            <button type="button" class="px-2 py-1 border rounded" (click)="changeRevenueStagePage(revenueStageTableCurrentPage + 1)">›</button>
            <button type="button" class="px-2 py-1 border rounded" (click)="changeRevenueStagePage(revenueStageTableTotalPages)">»</button>
          </div>
          <div>
            <select [(ngModel)]="revenueStageTablePageSize" (change)="changeRevenueStagePageSize()" class="border rounded px-2 py-1">
              <option *ngFor="let size of revenueStageTablePageSizeOptions" [value]="size">{{ size }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<!-- Fullscreen chart dialog -->
<p-dialog [(visible)]="fullscreenVisible" [modal]="true" styleClass="revenue-fullscreen-dialog" appendTo="body">
  <ng-template pTemplate="header">
    <h5 class="fw-bold m-0">Chart</h5>
  </ng-template>
  <p-chart [type]="fullscreenChart.type" [data]="fullscreenChart.data" [options]="fullscreenChart.options || chartOptions"></p-chart>
</p-dialog>

<p-dialog header="Proposal Details" [(visible)]="detailsModalOpen" [modal]="true" [draggable]="false" [resizable]="true"
  [maximizable]="true" [closable]="true" styleClass="revenue-proposal-details-dialog" appendTo="body">
  <div class="form-wrapper">
    <form [formGroup]="proposalForm">
      <div class="form-container">
        <!-- Basic Information Section -->
        <div class="form-section">
          <h3 class="section-title">Basic Information</h3>
          <div class="form-grid">
            <div class="form-field full-width">
              <label for="nomenclature">Nomenclature <span class="required-asterisk">*</span></label>
              <input pInputText id="nomenclature" pSize="large" formControlName="nomenclature" autocomplete="off" />
            </div>
          </div>
        </div>

        <!-- Equipment & System Section -->
        <div class="form-section">
          <h3 class="section-title">Equipment & System</h3>
          <div class="form-grid">
            <div class="form-field">
              <label for="equipment">Equipment <span class="required-asterisk">*</span></label>
              <p-dropdown formControlName="equipment" [options]="filteredEquipment" placeholder="Select Equipment"
                optionLabel="name" optionValue="id" [filter]="true" filterBy="name">
              </p-dropdown>
              <div *ngIf="
                proposalForm.get('equipment')?.invalid &&
                proposalForm.get('equipment')?.touched
              " class="error-message">
                Equipment selection is required
              </div>
            </div>

            <div class="form-field">
              <label for="system">System <span class="required-asterisk">*</span></label>
              <p-dropdown formControlName="system" [options]="filteredSystem" placeholder="Select System"
                optionLabel="name" optionValue="id" [filter]="true" filterBy="name">
              </p-dropdown>
              <div *ngIf="
                proposalForm.get('system')?.invalid &&
                proposalForm.get('system')?.touched
              " class="error-message">
                System selection is required
              </div>
            </div>
          </div>
        </div>

        <!-- Quantity Section -->
        <div class="form-section">
          <h3 class="section-title">Quantity Details</h3>
          <div class="form-grid">
            <div class="form-field">
              <label for="qtyReqd">Quantity Required <span class="required-asterisk">*</span></label>
              <input pInputText id="qtyReqd" pSize="large" formControlName="qtyReqd" autocomplete="off"
                (keypress)="allowOnlyNumbers($event)" />
            </div>

            <div class="form-field">
              <label for="qtyPrototype">Quantity Prototype
                <span class="required-asterisk">*</span></label>
              <input pInputText id="qtyPrototype" pSize="large" formControlName="qtyPrototype" autocomplete="off"
                (keypress)="allowOnlyNumbers($event)" />
            </div>

            <div class="form-field">
              <label for="qtyBulk">Quantity Bulk (MoQ)
                <span class="required-asterisk">*</span></label>
              <input pInputText id="qtyBulk" pSize="large" formControlName="qtyBulk" autocomplete="off"
                (keypress)="allowOnlyNumbers($event)" />
            </div>
          </div>
        </div>

        <!-- Cost Section -->
        <div class="form-section">
          <h3 class="section-title">Cost Details</h3>
          <div class="form-grid">
            <div class="form-field">
              <label for="estimatedDevelopmentCost">Estimated Development Cost</label>
              <input pInputText id="estimatedDevelopmentCost" pSize="large" formControlName="estimatedDevelopmentCost"
                autocomplete="off" (keypress)="allowOnlyNumbers($event)" />
            </div>

            <div class="form-field">
              <label for="estimatedUnitCost">Estimated Unit Cost</label>
              <input pInputText id="estimatedUnitCost" pSize="large" formControlName="estimatedUnitCost"
                autocomplete="off" (keypress)="allowOnlyNumbers($event)" />
            </div>

            <div class="form-field">
              <label for="llp">LLP Cost</label>
              <input pInputText id="llp" pSize="large" formControlName="llp" autocomplete="off"
                (keypress)="allowOnlyNumbers($event)" />
            </div>

            <div class="form-field">
              <label for="poev">POEV Cost</label>
              <input pInputText id="poev" pSize="large" formControlName="poev" autocomplete="off"
                (keypress)="allowOnlyNumbers($event)" />
            </div>

            <div class="form-field">
              <label for="consignee">Consignee</label>
              <input pInputText id="consignee" pSize="large" formControlName="consignee" autocomplete="off" />
            </div>
          </div>
        </div>

        <!-- Rich Text Editors Section -->
        <div class="form-section">
          <h3 class="section-title">Detailed Information</h3>

          <div class="editor-field" [class.readonly-editor]="isEditorDisabled">
            <label>Brief Description/Technical Details</label>
            <editor [init]="init" formControlName="technologyInsertion" [disabled]="isEditorDisabled"></editor>
          </div>

          <div class="editor-field" [class.readonly-editor]="isEditorDisabled">
            <label>Justification for progressing the case under sub category</label>
            <editor [init]="init" formControlName="justificationText" [disabled]="isEditorDisabled"></editor>
          </div>

          <div class="editor-field" [class.readonly-editor]="isEditorDisabled">
            <label>Any export potential of the proposed item</label>
            <editor [init]="init" formControlName="exportPotential" [disabled]="isEditorDisabled"></editor>
          </div>

          <div class="editor-field" [class.readonly-editor]="isEditorDisabled">
            <label>Formulation & approval of SOTRs</label>
            <editor [init]="init" formControlName="approvalOfSOTRs" [disabled]="isEditorDisabled"></editor>
          </div>

          <div class="editor-field" [class.readonly-editor]="isEditorDisabled">
            <label>Details/ Comments from DRDO/ IA/ IAF/ HQIDS (if available)</label>
            <editor [init]="init" formControlName="approvalOfSOTRs" [disabled]="isEditorDisabled"></editor>
          </div>
        </div>

        <!-- File Uploads Section -->
        <div class="form-section">
          <h3 class="section-title">Document Uploads</h3>
          <app-upload-document></app-upload-document>
          <!-- Uploaded Draft SOTR -->
          <!-- <ng-container *ngIf="selectedProposal?.draft_sotr; else noDraft">
              <div class="uploaded-files">
                <h5>Uploaded Draft SOTR</h5>
                <ul>
                  <li>
                    <a href="{{ baseUrl + selectedProposal?.draft_sotr }}" target="_blank" rel="noopener noreferrer">
                      {{ getFileName(selectedProposal?.draft_sotr) }}
                    </a>
                  </li>
                </ul>
              </div>
            </ng-container> -->
          <ng-template #noDraft>
            <p class="text-muted">No Draft SOTR uploaded.</p>
          </ng-template>

          <!-- Upload Draft SOTR -->
          <!-- <div class="upload-field">
              <label for="draftSotr" *ngIf="isEditMode">Draft SOTR <span class="required-asterisk">*</span></label>
              <p-fileUpload name="draftSotr[]" #draftSotrUpload [customUpload]="true" [auto]="true"
                [accept]="'.pdf,.docx,.csv,.jpeg,.jpg,.png'" [maxFileSize]="209715200" *ngIf="isEditMode"
                (onSelect)="onFileSelect($event, 'draftSotr')" [multiple]="false" mode="advanced">
                <ng-template #empty>
                  <p>Drag and drop the draft SOTR file here to upload.</p>
                </ng-template>
              </p-fileUpload>

              <div *ngIf="draftSotrUpload?.files?.length">
                <h5 class="mt-3">Attached Draft SOTR</h5>
                <ul>
                  <li *ngFor="let f of draftSotrUpload.files">{{ f.name }}</li>
                </ul>
              </div>
            </div> -->

          <hr />

          <!-- Uploaded Supporting Docs -->
          <ng-container *ngIf="selectedProposal?.need_files?.length; else noSupportingDocs">
            <div class="uploaded-files">
              <h5>Uploaded Supporting Documents</h5>
              <ul>
                <li *ngFor="let file of selectedProposal?.need_files">
                  <a href="{{ baseUrl + file.file }}" target="_blank" rel="noopener noreferrer">
                    {{ getFileName(file.file) }}
                  </a>
                </li>
              </ul>
            </div>
          </ng-container>
          <ng-template #noSupportingDocs>
            <p class="text-muted">No supporting documents uploaded.</p>
          </ng-template>

          <!-- Upload Supporting Docs -->
          <!-- <div class="upload-field">
              <label for="supportingDocs" *ngIf="isEditMode">Supporting Documents
                <span class="required-asterisk">*</span></label>
              <p-fileUpload name="demo[]" #fileUpload [customUpload]="true" [accept]="'.pdf,.docx,.csv,.jpeg,.jpg,.png'"
                [maxFileSize]="209715200" [auto]="true" (onSelect)="onFileSelect($event, 'supportingDocs')"
                [multiple]="true" mode="advanced" *ngIf="isEditMode">
                <ng-template #empty>
                  <p>Drag and drop files here to upload.</p>
                </ng-template>
              </p-fileUpload>
              
              <div *ngIf="fileUpload?.files?.length">
                <h5 class="mt-3">Attached Supporting Documents</h5>
                <ul>
                  <li *ngFor="let f of fileUpload.files">{{ f.name }}</li>
                </ul>
              </div>
            </div> -->
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <button type="submit" class="btn btn-primary" *ngIf="isEditMode" (click)="onSubmit()"
          [disabled]="proposalForm.invalid">Submit</button>
      </div>
    </form>
  </div>
</p-dialog>


<p-dialog header="Approval Remarks" [(visible)]="routeModal" [modal]="true" styleClass="revenue-approval-remarks-dialog" appendTo="body"
  [maximizable]="true">
  <!-- Selected challenges -->
  <!-- <h5 class="mt-3 mb-2">Selected Challenges</h5>
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Challenge Name</th>
          <th>Title</th>
          <th>Category</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let challenge of selectedChallenges || []">
          <td>{{ challenge.proposal_name }}</td>
          <td>{{ challenge.title }}</td>
          <td>{{ challenge.category }}</td>
        </tr>
      </tbody>
    </table> -->

  <div class=" mt-3">
    <div class="card-header mb-2">
      <h5 class="mb-0">Add your remarks (Optional)</h5>
    </div>
    <p-floatLabel variant="in" class="mt-2 w-100">
      <textarea pInputTextarea id="DocName" rows="4" [(ngModel)]="IRAremarks" autocomplete="off"
        class="w-100"></textarea>
    </p-floatLabel>
  </div>

  <!-- Dropdowns -->
  <form [formGroup]="routeForm" class="mt-4 mb-4">
    <!-- formulation of challenge step -->
    <!-- <div class="card-header mb-2">
        <h5 class="mb-0" *ngIf="filteredProposals[0]?.proposal_step_status== '0' && filteredProposals[0]?.type == 'formulation challenge' && userID == '1'">
         Send for APSO Approval</h5>
         <h5 class="mb-0" *ngIf="filteredProposals[0]?.proposal_step_status== 'initiated' && filteredProposals[0]?.type == 'formulation challenge' && userID == '3'">
         Send to DOI</h5>
      </div> -->
    <!-- Initiation of challenge step -->
    <!-- <div class="card-header mb-2">
        <h5 class="mb-0" *ngIf="filteredProposals[0]?.proposal_step_status== '0' && filteredProposals[0]?.type == 'initiation challenge' && userID == '1'">
         Send for Recommendation/Approval</h5>
         <h5 class="mb-0" *ngIf="filteredProposals[0]?.proposal_step_status== 'initiated' && filteredProposals[0]?.type == 'initiation challenge' && userID == '3'">
         Send to VCNS</h5>
      </div> -->
    <div class="row" *ngIf="userID != '3'">

      <div class="col-md-12 mb-3 px-3">
        <label>Role</label>
        <p-dropdown [options]="roleList" formControlName="role" optionValue="id" optionLabel="name" [filter]="true"
          filterBy="name" placeholder="Select a Role" class="w-100" (onChange)="onRoleChange($event)" appendTo="body">
        </p-dropdown>
      </div>
      <!-- <div class="col-md-6 mb-3  px-3">
          <label>Directorate</label>
          <p-dropdown [options]="unitList" formControlName="unit" optionValue="id" optionLabel="name"
            placeholder="Select a Directorate" class="w-100" (onChange)="onUnitChange($event)" [filter]="true"
            filterBy="name" appendTo="body">
          </p-dropdown>
        </div> -->
    </div>
    <div class="col-md-12 mb-3  px-3" *ngIf="userID != '3'">
      <label>User</label>
      <p-dropdown [options]="userList" formControlName="user" optionValue="id" optionLabel="first_name"
        placeholder="Select a User" class="w-100" [filter]="true" filterBy="first_name" appendTo="body"
        (onChange)="onUserChange($event)">
        <ng-template let-user pTemplate="item">
          <div class="list-group-item list-group-item-action">
            <small>{{user.unit.name}} - {{user.hrcdf_designation}} {{ user.first_name }} {{ user.last_name }} - {{
              user.loginname }}</small>
          </div>
        </ng-template>
      </p-dropdown>
    </div>


  </form>

  <!-- Footer -->
  <div class="d-flex justify-content-end">
    <button class="btn btn-secondary me-4" (click)="routeModal = false">
      Cancel
    </button>
    <button class="btn btn-success" (click)="submitIRA();">
      Approve and Send
    </button>
  </div>
</p-dialog>